import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './BlogsListing.css';

function BlogsListing() {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Investment', 'Legal', 'Technology', 'Market Trends', 'Guides'];

  const allArticles = [
    {
      id: 1,
      title: 'Top 10 Investment Areas in Karachi 2024',
      description: 'Discover the most promising real estate investment opportunities in Pakistan\'s largest city.',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      category: 'Investment',
      date: 'Dec 28, 2024',
      readTime: '5 min read'
    },
    {
      id: 2,
      title: 'Understanding Property Ownership Laws in Pakistan',
      description: 'A comprehensive guide to property ownership, transfer, and legal requirements.',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
      category: 'Legal',
      date: 'Dec 25, 2024',
      readTime: '8 min read'
    },
    {
      id: 3,
      title: 'Smart Home Features That Add Value',
      description: 'How modern technology can increase your property\'s market value and appeal.',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
      category: 'Technology',
      date: 'Dec 22, 2024',
      readTime: '6 min read'
    },
    {
      id: 4,
      title: 'Lahore Real Estate Market Analysis 2024',
      description: 'In-depth analysis of property prices and trends in Lahore\'s major areas.',
      image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&q=80',
      category: 'Market Trends',
      date: 'Dec 20, 2024',
      readTime: '7 min read'
    },
    {
      id: 5,
      title: 'First-Time Home Buyer\'s Complete Guide',
      description: 'Everything you need to know about buying your first property in Pakistan.',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      category: 'Guides',
      date: 'Dec 18, 2024',
      readTime: '10 min read'
    },
    {
      id: 6,
      title: 'Commercial Property Investment Opportunities',
      description: 'Exploring lucrative commercial real estate options across major cities.',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
      category: 'Investment',
      date: 'Dec 15, 2024',
      readTime: '6 min read'
    },
    {
      id: 7,
      title: 'Property Tax Guide for 2024',
      description: 'Understanding property taxes, exemptions, and how to calculate your liability.',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
      category: 'Legal',
      date: 'Dec 12, 2024',
      readTime: '5 min read'
    },
    {
      id: 8,
      title: 'Sustainable Living: Eco-Friendly Homes',
      description: 'How green building practices are changing Pakistan\'s real estate landscape.',
      image: 'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&q=80',
      category: 'Technology',
      date: 'Dec 10, 2024',
      readTime: '6 min read'
    },
    {
      id: 9,
      title: 'Islamabad Property Market Forecast',
      description: 'Expert predictions on price movements and investment opportunities in the capital.',
      image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&q=80',
      category: 'Market Trends',
      date: 'Dec 8, 2024',
      readTime: '8 min read'
    }
  ];

  const filteredArticles = selectedCategory === 'All'
    ? allArticles
    : allArticles.filter(article => article.category === selectedCategory);

  const handleArticleClick = (articleId) => {
    if (window.navigateTo) {
      window.navigateTo('blog-detail');
    } else {
      alert(`Navigating to article ${articleId}`);
    }
  };

  return (
    <div className="blogs-listing-page">
      <Header />

      <div className="blogs-container">
        <div className="blogs-hero">
          <h1>Real Estate Insights & Guides</h1>
          <p>Expert advice, market trends, and comprehensive guides for property buyers, sellers, and investors</p>
        </div>

        <div className="blogs-content">
          <div className="category-filter">
            {categories.map(category => (
              <button
                key={category}
                className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="articles-grid">
            {filteredArticles.map(article => (
              <div
                key={article.id}
                className="article-card"
                onClick={() => handleArticleClick(article.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleArticleClick(article.id)}
              >
                <div className="article-image">
                  <img src={article.image} alt={article.title} />
                  <div className="article-category">{article.category}</div>
                </div>
                <div className="article-content">
                  <div className="article-meta">
                    <span>{article.date}</span>
                    <span className="separator">•</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3>{article.title}</h3>
                  <p>{article.description}</p>
                  <span className="read-more">Read More →</span>
                </div>
              </div>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div className="no-articles">
              <p>No articles found in this category.</p>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BlogsListing;
